<template>
    <div>
        <el-col :span="24" class='btm-action'>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.pageIndex" :page-sizes="pageSizes" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="query.total*1" style="float: right">
            </el-pagination>
        </el-col>
    </div>
</template>

<script>
import { isCorrectVal } from 'utils';

export default {
    props: {
        span: 24,
        pageSizes: {
            type: Array,
            default() { // 默认为空数组
                return [10, 20, 50];
            }
        },
        query: {}
    },
    created() {
        //this.handleCurrentChange();
    },
    data() {
        return {
        };
    },
    methods: {
        handleSizeChange: function (val) {
            this.query.pageSize = val;
            this.$emit('getDataList');// 向上派发 select事件，参数：评论类型
        },
        handleCurrentChange: function (val) {
            this.query.pageIndex = val;
            this.$emit('getDataList');// 向上派发 select事件，参数：评论类型
        }
    }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// pagination.vue?00c730f0